import $ from '@nuskin/nuskinjquery';
import {CartService, CurrencyService, OrderManager, PickupUtil} from '@nuskin/ns-shop';
import OrderUtil from './orderUtil.js';
import {events, PersonalOfferStorageService} from '@nuskin/ns-util';
import {getCachedConfigField} from '@nuskin/configuration-sdk';

/**
 *
 * CartUtil
 *
 * @namespace CartUtil
 */
const CartUtil = function() {
    'use strict';

    let $scope;

    // ---------------------------------------------
    //
    //        Public Methods
    //
    // ---------------------------------------------
    const publicMethods = {

        /**
         * Initializes CartUtil
         * @memberof CartUtil
         * @example
         * CartUtil.initCart(scope)
         */
        initCart: function(scope) {
            $scope = scope;

            $scope.orderDetailsHeader = $scope.tdc.orderDetails;

            // init public methods
            $scope.getLineItemClass = getLineItemClass;

            // removeItem called when delete item clicked in cart section
            $scope.removeItem = removeItem;

            // updateItem called when Qty changed in cart section
            $scope.updateItem = updateItem;

            // Hide the mini cart.
            $('#cart').hide();
            initDisplayInfo('cart');
            events.subscribe(events.shop.SIMULATE_COMPLETE, () => {
                apply(initDisplayInfo);
            });
        },

        /**
         * initializeCart does the first simulate and sets up the page
         * @memberof CartUtil
         * @example
         * CartUtil.initializeCart()
         */
        initializeCart: function() {
            // If we pulled the order from local storage then we don't need to simulate
            if (OrderUtil.getOrderFound()) {
                if ($scope.payments && !$scope.payments.$resolved && $scope.payments.$promise) {
                    $scope.payments.$promise.then(() => {
                        finishInitialize();
                    });
                    // initDisplayInfo('cart');
                } else {
                    finishInitialize();
                }
            } else {
                $scope.simulateOrder().then(function() {
                    if ($scope.overriddenADR) {
                        const shipMethodChanged = $scope.overriddenADR.SalesOrderDetail.Shipping.ShippingMethod.Code !== $scope.order.selectedShippingMethod.Code;
                        applyADRShippingMethod();
                        if (shipMethodChanged) {
                            $scope.simulateOrder().then(function() {
                                finishInitialize();
                            });
                        } else {
                            finishInitialize();
                        }
                    } else {
                        finishInitialize();
                    }
                });
                // initDisplayInfo('cart');
            }
        }
    };

    // ---------------------------------------------
    //
    //        Private Methods
    //
    // ---------------------------------------------
    function finishInitialize() {
        // send payment options returned by simulate to the vue component
        const paymentElement = document.getElementById('newPaymentSection');
        if (paymentElement) {
            const paymentOptions =
                $scope.order ? $scope.order.availablePayments : [];
            paymentElement.setAttribute('payment-options', JSON.stringify(paymentOptions));
        }

        // The contentLoaded flag shows the checkout page
        $scope.contentLoaded = true;
        const needToSelectPickupLocation = $scope.order.selectedShippingMethod &&
            PickupUtil.supports($scope.order.selectedShippingMethod.Code) &&
            !$scope.order.selectedPickupPoint;

        $scope.sections.initializeSections(needToSelectPickupLocation, !$scope.order.adr && $scope.paymentPref !== 'default');

        // If the payment section has already been marked complete then continue to the next section
        if ($scope.paymentState === 'complete') {
            $scope.continueEdit('payment');
        }

        initDisplayInfo();

        if ($scope.order.infoMsg) {
            $scope.sections.cart.error.infoMessages.push({text: $scope.order.infoMsg});
        }
    }

    function applyADRShippingMethod() {
        const adrShippingMethod = $scope.overriddenADR.SalesOrderDetail.Shipping.ShippingMethod;
        const matchingMethod = $scope.order.shippingAvailableMethods.find(
            (method) =>
                method.Code === adrShippingMethod.Code &&
                (!adrShippingMethod.PickUpLocation ||
                    method.PickUpLocation === adrShippingMethod.PickUpLocation)
        );
        if (matchingMethod) {
            $scope.order.selectedShippingMethod = matchingMethod;
        }
    }

    function initDisplayInfo(itemOrigin = 'sap') {
        const orderItems = JSON.parse(`{"${itemOrigin}OrderItems": true}`);
        const adrItems = JSON.parse(`{"${itemOrigin}AdrItems": true}`);
        const totalItems = JSON.parse(`{"${itemOrigin}Items": true}`);
        const order = OrderManager.getOrder();

        $scope.sapOrderItems = [];
        $scope.sapAdrItems = [];
        if ($scope.order.adr) {
            if ($scope.order.singleFlow) {
                $scope.sapOrderItems = CartService.getItemData(orderItems);
                $scope.sapAdrItems = CartService.getItemData(adrItems);
                $scope.sapItemQty = CartService.getItemCnt(totalItems);
            } else {
                $scope.sapAdrItems = CartService.getItemData(adrItems);
                $scope.sapItemQty = CartService.getItemCnt(adrItems);
            }
        } else {
            $scope.sapOrderItems = CartService.getItemData(orderItems);
            $scope.sapItemQty = CartService.getItemCnt(orderItems);
        }

        if (getCachedConfigField('enabled')) {
            $scope.orderLoyaltyEarnings = CartService.calculateLoyaltyEarnings(undefined, true);
        }
        // This function is called anytime we simulate.  Now that we have all the updated items update the order object with the new merged sapItems list
        // order.sapItems is used to display the info on the google pay and apple pay payment screen.
        order.sapItems = $scope.sapItems = $scope.sapOrderItems.concat($scope.sapAdrItems);
        OrderManager.saveOrders();

        if (itemOrigin === 'cart') {
            $scope.itemSubtotal = 0;
            $scope.psvTotal = 0;

            // set price to take into account qty
            $scope.sapItems.forEach((item) => {
                item.price = item.price * item.qty;
                $scope.itemSubtotal += item.price;
                $scope.psvTotal += item.psv;
            });
            const personalOffer = PersonalOfferStorageService.getPersonalOffer();

            if (PersonalOfferStorageService.isPersonalOffer() && personalOffer.discount && personalOffer.discount.code !== 'RETAILPRICE') {
                $scope.grandTotal = $scope.itemSubtotal * personalOffer.discount.multiplier;
                $scope.pitchDiscountCodeApplied = true;
            } else {
                $scope.grandTotal = $scope.itemSubtotal;
                $scope.pitchDiscountCodeApplied = false;
            }

            $scope.dispShipping = $scope.tdc.preTaxShippingText;
            $scope.dispTax = $scope.tdc.preTaxShippingText;
            $scope.preSubtotalDisclaimer = $scope.tdc.orderSubotalDisclaimer;
            $scope.preTotalDisclaimer = $scope.tdc.orderTotalDisclaimer;
        } else {
            $scope.dispShipping = $scope.order.orderTotals.shipping <= 0 ?
                $scope.tdc.freeShipping :
                CurrencyService.format($scope.order.orderTotals.shipping, $scope.runConfig.country, $scope.runConfig.language);
            $scope.dispTax = CurrencyService.format($scope.order.orderTotals.tax, $scope.runConfig.country, $scope.runConfig.language);
            $scope.preSubtotalDisclaimer = '';
            $scope.preTotalDisclaimer = '';
            $scope.itemSubtotal = $scope.order.orderTotals.itemSubtotal;
            $scope.psvTotal = $scope.order.orderTotals.psvTotal;
            $scope.grandTotal = $scope.order.orderTotals.grandTotal;
            $scope.pitchDiscountCodeApplied = false;
        }

        if (!($scope.order.productDiscountCode || $scope.order.shippingDiscountCode)) {
            $scope.recurringSubTotal = $scope.sapAdrItems.reduce((acc, item) => acc + item.price, 0);
        }
        $scope.itemDisplay1 = !$scope.showPsv;
        $scope.itemDisplay2 = $scope.showPsv && ($scope.sapOrderItems.some((sapItem) => sapItem.price < 10000000) ||
            $scope.sapAdrItems.some((sapItem) => sapItem.price < 10000000));
        $scope.itemDisplay3 = $scope.showPsv && !$scope.itemDisplay2;
    }

    function getLineItemClass(itemData) {
        if (itemData.isAdr && !itemData.isBusinessPortfolio) {
            return 'adrRow';
        }
        return 'noAdrRow';
    }
    function removeItem(item) {
        if (CartService.getItemCnt() > 1) {
            $scope.sections.cart.modified=true;
            CartService.removeItemByKey(item.key);
        }
    }
    function updateItem(item) {
        let isRevertingOld = false;

        if (item.qty <= 0) {
            if (CartService.getItemCnt() > 1) {
                CartService.removeItemByKey(item.key);
            } else {
                // alert("Cannot remove the last item....");
                isRevertingOld = true;
            }
        } else {
            $scope.sections.cart.modified=true;
        }

        return isRevertingOld;
    }

    function apply(_callback) {
        const callback = _callback || function() {};

        if ($scope.$$phase != '$apply' && $scope.$$phase != '$digest') {
            callback();
            $scope.$apply();
        } else {
            callback();
        }
    }

    return publicMethods;
}();

export default CartUtil;
